import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ProductForm from './ProductForm';
import FormToolbar from '../shared/FormToolbar';

const redirect = basePath => basePath.replace('products', 'product_groups');

const ProductEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect={redirect}
    >
      <ProductForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ProductEdit;
